import moment from 'moment';
import * as React from 'react';
import { DateTimePicker } from 'react-widgets';
import { FilterProps } from './types';

moment.locale('en');

function dateFilterMulti<T extends Record<string, unknown>>(): React.FunctionComponent<FilterProps<T>> {
    return React.memo(({ column: { setFilter, id } }: FilterProps<T>) => {
        const [date, setDate] = React.useState<any>({});
        const handleChange1 = (value: Date | undefined) => {
            if (value) {
                if (Object.values(date).length) {
                    setDate({ ...date, [`${id}[after]`]: moment(value).format('YYYY-MM-DD') });
                    setFilter({ ...date, [`${id}[after]`]: moment(value).format('YYYY-MM-DD') });
                } else {
                    setDate({ ...date, [`${id}[after]`]: moment(value).format('YYYY-MM-DD') });
                }
            }
        };

        // The filtered columns hold a datetime, and `[before]` compares against the stored value, so a
        // bare date means midnight and hides every row of the picked day — picking the same date in
        // both fields returned nothing. The upper bound has to be the end of that day.
        const handleChange2 = (value: Date | undefined) => {
            if (value) {
                const to = moment(value).endOf('day').format('YYYY-MM-DD HH:mm:ss');

                if (Object.values(date).length) {
                    setDate({ ...date, [`${id}[before]`]: to });
                    setFilter({ ...date, [`${id}[before]`]: to });
                } else {
                    setDate({ ...date, [`${id}[before]`]: to });
                }
            }
        };

        return (
            <div className={'d-flex'} style={{ minWidth: 230 }}>
                <DateTimePicker format="MM-DD-YYYY" time={false} onChange={handleChange1} />
                <DateTimePicker format="MM-DD-YYYY" time={false} onChange={handleChange2} />
            </div>
        );
    });
}

export default dateFilterMulti;
